import { create } from 'zustand';

const savedLanguage = localStorage.getItem('language') || 'ar';
const savedTheme = localStorage.getItem('theme') || 'light';

export const useUIStore = create((set, get) => ({
  language: savedLanguage,
  direction: savedLanguage === 'ar' ? 'rtl' : 'ltr',
  sidebarOpen: true,
  theme: savedTheme,

  /** Cached school profile (name, logo). Populated after login. */
  schoolProfile: null,
  setSchoolProfile: (profile) => set({ schoolProfile: profile }),

  /** Toggle between Arabic and English, updating direction accordingly. */
  toggleLanguage: () => {
    const current = get().language;
    const next = current === 'ar' ? 'en' : 'ar';
    const dir = next === 'ar' ? 'rtl' : 'ltr';

    localStorage.setItem('language', next);
    document.documentElement.dir = dir;
    document.documentElement.lang = next;

    set({ language: next, direction: dir });
  },

  /** Set language explicitly. */
  setLanguage: (lang) => {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem('language', lang);
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
    set({ language: lang, direction: dir });
  },

  /** Toggle sidebar open/closed. */
  toggleSidebar: () => {
    set((s) => ({ sidebarOpen: !s.sidebarOpen }));
  },

  /** Toggle between light and dark themes. */
  toggleTheme: () => {
    const next = get().theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', next);
    set({ theme: next });
  },
}));
